export default {
  
  getProduct: { method: 'get', url: 'product/colecoes/products/?id={id_produto}' },
  
  }
  